import { useEffect, useState } from 'react';
import { notificationService } from '@/lib/notifications';

export const useNotifications = (isAuthenticated: boolean = false) => {
  const [isInitialized, setIsInitialized] = useState(false);
  const [fcmToken, setFcmToken] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // Only initialize notifications if user is authenticated
    if (!isAuthenticated) {
      console.log('Notifications: User not authenticated, skipping initialization');
      setIsInitialized(false);
      setFcmToken(null);
      setError(null);
      return;
    }

    const initializeNotifications = async () => {
      try {
        console.log('Notifications: Initializing for authenticated user (no permission request)');
        const token = await notificationService.initialize(false); // Don't request permissions
        setFcmToken(token);
        setIsInitialized(true);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to initialize notifications');
        console.error('Notification initialization error:', err);
      }
    };

    initializeNotifications();
  }, [isAuthenticated]);

  return {
    isInitialized,
    fcmToken,
    error,
    getDeviceId: () => notificationService.getDeviceId(),
    getPlatform: () => notificationService.getPlatform(),
  };
};
